export default __webpack_public_path__ + "static/media/Responsive.ea2aeb69.svg";